/**
 * Order validation utilities
 * Extracted from Order.js for better maintainability and testability
 */

/**
 * Validate an order before submission
 * @param {Object} studentInfo - Student information object with firstName and lastName
 * @param {Object} order - Order object containing orderTotal and isDonate
 * @param {Object} shippingInfo - Shipping information object with shippingType and message
 * @returns {Object} - Validation result with isValid boolean and message string
 */
export const validateOrderSubmission = (studentInfo, order, shippingInfo = null) => {
    if (!studentInfo.firstName || studentInfo.firstName.length === 0) {
        return { 
            isValid: false, 
            message: "Please enter a first name for the student." 
        };
    }
    
    if (!studentInfo.lastName || studentInfo.lastName.length === 0) {
        return { 
            isValid: false, 
            message: "Please enter a last name for the student." 
        };
    }
    
    if (!order.isDonate && (!order.orderTotal || order.orderTotal <= 0)) {
        return { 
            isValid: false, 
            message: "Please select an item." 
        };
    }
    
    if (!order.orderTotal || (order.isDonate && order.orderTotal < 35)) {
        return { 
            isValid: false, 
            message: "Donation must be at least $35.00." 
        };
    }
    
    // Validate shipping if shipping information is provided
    if (shippingInfo) {
        // ShippingType: 0=NoShipping, 1=AddressRequired/Error, 2=Calculated
        if (shippingInfo.shippingType === 1) {
            const errorMessage = shippingInfo.message || "Please complete the shipping address or resolve shipping errors before proceeding.";
            return {
                isValid: false,
                message: errorMessage
            };
        }
    }
    
    return { 
        isValid: true, 
        message: null 
    };
};
